import React from 'react';
import { Card, Skeleton } from 'antd';
import { Box } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';

export default function CargandoCreadorEncargos() {
  return (
    <TwoColumnsFlexLayout
      preset="golden"
      leftContent={(
        <Box>
          <Card>
            <Skeleton active title={false} paragraph={{ rows: 3 }} />
          </Card>
          <Card>
            <Skeleton active title={false} paragraph={{ rows: 2 }} />
          </Card>
          <Card>
            <Skeleton active title={false} />
          </Card>
          <Box pt="16">
            <Skeleton active title={false} paragraph={{ rows: 4 }} />
          </Box>
        </Box>
      )}
      rightColumnStyle={{ paddingLeft: '16px' }}
      rightContent={(
        <Box>
          <Card>
            <Skeleton active title={false} paragraph={{ rows: 1 }} />
          </Card>
          <Card>
            <Skeleton active title={false} paragraph={{ rows: 1 }} />
          </Card>
          <Card>
            <Skeleton active title={false} paragraph={{ rows: 1 }} />
          </Card>
        </Box>
      )}
    />
  );
}
